// extracted by mini-css-extract-plugin
export default {"div":"BankEmployeeChange_div__0-6Xj","modal":"BankEmployeeChange_modal__d70gO"};